import { WALLET_STATE } from './constants'
import { createSelector } from 'reselect'

const getWalletAmount = state => state[WALLET_STATE]?.amount
const getWalletCurrency = state => state[WALLET_STATE]?.currency

export const isFetching = state => state[WALLET_STATE]?.isFetching
export const isCheck = state => state[WALLET_STATE]?.isCheck

export const getWalletCredit = createSelector(
  [getWalletAmount, getWalletCurrency],
  (amount, currency) => ({ amount, currency })
)
